const search = {
    init: function() {
        this.toggleEvent();
    },

    togglePopup: () => {
        const popup = document.getElementById('popup-search');
        const html = document.querySelector('html');
        const searchField = document.getElementById('searchInput');

		html.classList.toggle('noScroll')
		popup.classList.toggle('active');

        if(popup.classList.contains('active')){
            searchField.focus();
        }    
    },

    toggleEvent: function() {
		const togglers = document.querySelectorAll('#btnSearch, .popupSearch__close');
		if( togglers ){
			togglers.forEach(toggler => {
				toggler.addEventListener('click', this.togglePopup);
			});
		}
    }
};

export default search;